import React from 'react';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import {
  EMPTY_STATEMENT_FILTERS,
  STATEMENT_SCHEDULE_STATUS_FILTER_OPTIONS,
  StatementScheduledEmailFilterFields,
} from '../filterStatementScheduledEmails';

interface Props {
  filters: StatementScheduledEmailFilterFields;
  onChange: (filters: StatementScheduledEmailFilterFields) => void;
  onClear: () => void;
}

const StatementScheduledEmailFilters: React.FC<Props> = ({ filters, onChange, onClear }) => {
  const handleChange = <K extends keyof StatementScheduledEmailFilterFields>(
    key: K,
    value: StatementScheduledEmailFilterFields[K],
  ) => {
    onChange({ ...filters, [key]: value });
  };

  const hasActiveFilters =
    filters.company.trim() !== '' ||
    filters.nextSendDate.trim() !== '' ||
    filters.status !== '';

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Company"
          value={filters.company}
          onChange={(e) => handleChange('company', e.target.value)}
          size="small"
          fullWidth
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Next Send"
          value={filters.nextSendDate}
          onChange={(e) => handleChange('nextSendDate', e.target.value)}
          size="small"
          fullWidth
          variant="outlined"
          placeholder="mm/dd/yyyy"
          inputProps={{ inputMode: 'numeric', 'aria-label': 'Next send date filter mm/dd/yyyy' }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormControl size="small" fullWidth>
          <InputLabel id="statement-scheduled-email-filter-status">Status</InputLabel>
          <Select
            labelId="statement-scheduled-email-filter-status"
            label="Status"
            value={filters.status}
            onChange={(e) => handleChange('status', e.target.value as StatementScheduledEmailFilterFields['status'])}
          >
            <MenuItem value="">All</MenuItem>
            {STATEMENT_SCHEDULE_STATUS_FILTER_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md="auto">
        <Button variant="outlined" size="small" onClick={onClear} disabled={!hasActiveFilters} sx={{ mb: 0.25 }}>
          Clear filters
        </Button>
      </Grid>
    </Grid>
  );
};

export { EMPTY_STATEMENT_FILTERS };
export default StatementScheduledEmailFilters;
